export default __webpack_public_path__ + "static/rental-129abc7c9208a3a69cd9dabc2c733bcf.jpg";